// iter v28 r466 — Pagina interna per registrare video MP4 dei mockup landing.
// Usata SOLO da Playwright via /mockup-recorder?id=xxx per generare i 9 MP4
// del social-kit. Non linkata dall'app, non SEO, no auth: pubblica.

import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import HeroAgendaMockup from "@/pages/landing/HeroAgendaMockup";
import HeroSopralluogoMockup from "@/pages/landing/HeroSopralluogoMockup";
import HeroMessaggiMockup from "@/pages/landing/HeroMessaggiMockup";
import HeroVolantinoFlip from "@/pages/landing/HeroVolantinoFlip";
import HeroAssistantMockup from "@/pages/landing/HeroAssistantMockup";
import IPhone17ProFrame from "@/components/IPhone17ProFrame";

/**
 * Componente animato BEFORE/AFTER con animazione MODERNA stile iPhone 17 Pro:
 *  - crossfade + scale-in del frame "dopo" (spring physics-like)
 *  - badge che entra con slide+fade
 *  - glassmorphism sul badge "dopo"
 *  - chip con micro-pulse sull'attivo
 */
function BeforeAfterAnimated({ before, after, beforeBadge, afterBadge, chips, activeChip = 0, appName }) {
  const [showAfter, setShowAfter] = useState(false);
  useEffect(() => {
    const t = setInterval(() => setShowAfter((s) => !s), 3200);
    return () => clearInterval(t);
  }, []);
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", background: "#FFFFFF" }}>
      {/* App header moderno */}
      <div style={{
        padding: "44px 22px 12px",  // più alto per Dynamic Island
        display: "flex", justifyContent: "space-between", alignItems: "center",
        background: "rgba(255,255,255,0.85)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        borderBottom: "1px solid rgba(226,222,210,0.5)",
        position: "relative", zIndex: 6,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 15, fontWeight: 600, color: "#1C1C1A", letterSpacing: "-0.01em" }}>
          <span style={{ color: "#9A968B", fontSize: 22, fontWeight: 300 }}>‹</span> {appName}
        </div>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.24em", color: "#7C8B6E" }}>PRONTO</div>
      </div>
      {/* Photo area con animazione spring */}
      <div style={{ flexGrow: 1, position: "relative", overflow: "hidden", background: "#F0EDE8" }}>
        <img
          src={before}
          alt="prima"
          style={{
            position: "absolute", inset: 0, width: "100%", height: "100%",
            objectFit: "cover",
            transition: "opacity 800ms cubic-bezier(0.22, 1, 0.36, 1), transform 1200ms cubic-bezier(0.22, 1, 0.36, 1)",
            opacity: showAfter ? 0 : 1,
            transform: showAfter ? "scale(1.05)" : "scale(1)",
          }}
        />
        <img
          src={after}
          alt="dopo"
          style={{
            position: "absolute", inset: 0, width: "100%", height: "100%",
            objectFit: "cover",
            transition: "opacity 800ms cubic-bezier(0.22, 1, 0.36, 1), transform 1200ms cubic-bezier(0.22, 1, 0.36, 1)",
            opacity: showAfter ? 1 : 0,
            transform: showAfter ? "scale(1)" : "scale(0.96)",
          }}
        />
        {/* Badge con glassmorphism */}
        <div
          style={{
            position: "absolute", top: 18, left: 18,
            padding: "8px 18px",
            borderRadius: 999,
            background: showAfter ? "rgba(124,139,110,0.92)" : "rgba(28,28,26,0.78)",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
            color: "#FFFFFF",
            fontSize: 12, fontWeight: 700, letterSpacing: "0.18em",
            transition: "all 600ms cubic-bezier(0.22, 1, 0.36, 1)",
            transform: showAfter ? "translateY(0)" : "translateY(0)",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            border: "1px solid rgba(255,255,255,0.12)",
            zIndex: 2,
          }}
        >
          {showAfter ? afterBadge : beforeBadge}
        </div>
      </div>
      {/* Chip row moderna */}
      <div
        style={{
          padding: "16px 18px 10px",
          background: "#FFFFFF",
          borderTop: "1px solid rgba(226,222,210,0.5)",
          display: "flex", gap: 8, overflow: "hidden",
        }}
      >
        {chips.map((c, i) => (
          <div
            key={i}
            style={{
              padding: "9px 16px",
              borderRadius: 999,
              fontSize: 12.5,
              fontWeight: 600,
              whiteSpace: "nowrap",
              letterSpacing: "-0.005em",
              border: "1.5px solid",
              background: i === activeChip ? "#1C1C1A" : "#FFFFFF",
              borderColor: i === activeChip ? "#1C1C1A" : "rgba(28,28,26,0.18)",
              color: i === activeChip ? "#FFFFFF" : "#1C1C1A",
              transition: "all 300ms ease",
              transform: i === activeChip && showAfter ? "scale(1.04)" : "scale(1)",
            }}
          >
            {c}
          </div>
        ))}
      </div>
      {/* Footer */}
      <div
        style={{
          padding: "10px 22px 18px",
          background: "#FFFFFF",
          fontSize: 11,
          letterSpacing: "0.22em",
          textTransform: "uppercase",
          color: "#7C8B6E",
          fontWeight: 700,
        }}
      >
        {showAfter ? "✦ pronto" : "tocca per generare"}
      </div>
    </div>
  );
}

// Wrappers per ogni servizio foto — con immagini PIÙ BELLE della landing
const ArredaVuotoAnim = () => (
  <BeforeAfterAnimated
    before="/landing/vuoto-before.jpg"
    after="/landing/vuoto-after.jpg"
    beforeBadge="VUOTA"
    afterBadge="ARREDATA"
    chips={["Moderno", "Scandinavo", "Classico", "Minimo"]}
    activeChip={1}
    appName="Arreda stanza vuota"
  />
);
const MigliorafotoAnim = () => (
  <BeforeAfterAnimated
    before="/landing/cucina-before.jpg"
    after="/landing/cucina-after.jpg"
    beforeBadge="ORIGINALE"
    afterBadge="MIGLIORATA"
    chips={["Migliora tutto", "Pronta", "Giusta", "Ok"]}
    activeChip={0}
    appName="Migliora foto"
  />
);
const RestylingAnim = () => (
  <BeforeAfterAnimated
    before="/landing/rinnova-before.jpg"
    after="/landing/rinnova-after.jpg"
    beforeBadge="DATATA"
    afterBadge="RINNOVATA"
    chips={["Moderno", "Scandinavo", "Industrial"]}
    activeChip={0}
    appName="Restyling stanza"
  />
);
const SvuotaStanzaAnim = () => (
  <BeforeAfterAnimated
    before="/landing/svuota-before.jpg"
    after="/landing/svuota-after.jpg"
    beforeBadge="ARREDATA"
    afterBadge="VUOTA"
    chips={["Svuota tutto"]}
    activeChip={0}
    appName="Svuota stanza"
  />
);

// VETRINA SCROLL: una singola vetrina in grande, scroll automatico verticale.
function VetrinaScrollMockup() {
  const scrollRef = React.useRef(null);
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    let start = null;
    const total = 6500;  // 6.5s di scroll
    function step(t) {
      if (start === null) start = t;
      const p = Math.min((t - start) / total, 1);
      const target = el.scrollHeight - el.clientHeight;
      el.scrollTop = target * p;
      if (p < 1) requestAnimationFrame(step);
    }
    const id = setTimeout(() => requestAnimationFrame(step), 600);
    return () => clearTimeout(id);
  }, []);
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", background: "#FFFFFF" }}>
      {/* Browser bar fake */}
      <div style={{
        padding: "10px 16px",
        display: "flex", alignItems: "center", gap: 8,
        borderBottom: "1px solid #E2DED2", background: "#F1F4ED",
      }}>
        <div style={{ display: "flex", gap: 6 }}>
          <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#E97464" }} />
          <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#E4B85F" }} />
          <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#7BBA6A" }} />
        </div>
        <div style={{
          flexGrow: 1, marginLeft: 12,
          fontSize: 12, fontWeight: 600,
          color: "#6B6A65", letterSpacing: "0.02em",
        }}>
          prontoimmo.it/v/bilocale-brera-via-solferino
        </div>
      </div>
      <div ref={scrollRef} style={{
        flexGrow: 1, overflow: "hidden",
        background: "#FAF8F4",
      }}>
        {/* Header brand agenzia */}
        <div style={{ padding: "14px 22px", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#FFFFFF", borderBottom: "1px solid #E2DED2" }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#1C1C1A", letterSpacing: "-0.01em" }}>
            <span style={{ color: "#7C8B6E" }}>STUDIO</span> BIANCHI
          </div>
          <div style={{ fontSize: 11, fontWeight: 600, color: "#6B6A65" }}>Milano · dal 2003</div>
        </div>
        {/* Cover */}
        <div style={{ position: "relative" }}>
          <img src="/landing/sala-after.jpg" alt="" style={{ width: "100%", aspectRatio: "16/10", objectFit: "cover", display: "block" }} />
          <div style={{
            position: "absolute", bottom: 14, left: 14,
            background: "rgba(28,28,26,0.85)", color: "#FFFFFF",
            padding: "8px 14px", borderRadius: 8, fontSize: 16, fontWeight: 700,
          }}>€ 480.000</div>
          <div style={{
            position: "absolute", top: 14, right: 14,
            background: "#7C8B6E", color: "#FFFFFF",
            padding: "5px 12px", borderRadius: 999, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em",
          }}>VETRINA SU MISURA</div>
        </div>
        {/* Title + meta */}
        <div style={{ padding: "20px 22px 14px" }}>
          <div style={{ fontSize: 22, fontWeight: 700, color: "#1C1C1A", letterSpacing: "-0.01em" }}>
            Bilocale a Brera
          </div>
          <div style={{ fontSize: 13, color: "#6B6A65", fontWeight: 500, marginTop: 4 }}>
            Via Solferino · Brera · Milano
          </div>
        </div>
        {/* Specs */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, padding: "0 22px 20px" }}>
          {[["72","mq"],["2","locali"],["1","bagno"]].map(([v, l]) => (
            <div key={l} style={{ background: "#FFFFFF", border: "1px solid #E2DED2", borderRadius: 10, padding: 10, textAlign: "center" }}>
              <div style={{ fontSize: 20, fontWeight: 700, color: "#1C1C1A" }}>{v}</div>
              <div style={{ fontSize: 10, letterSpacing: "0.1em", textTransform: "uppercase", color: "#7C8B6E", fontWeight: 700, marginTop: 2 }}>{l}</div>
            </div>
          ))}
        </div>
        {/* Description */}
        <div style={{ padding: "0 22px 20px" }}>
          <div style={{ fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", color: "#7C8B6E", fontWeight: 700, marginBottom: 8 }}>
            Descrizione
          </div>
          <div style={{ fontSize: 13.5, lineHeight: 1.55, color: "#1C1C1A", fontWeight: 400 }}>
            Bilocale di 72 mq al secondo piano di un palazzo storico nel cuore
            di Brera. Esposto a sud, doppia luce, finestre originali in legno.
            Cucina abitabile, salotto con camino, camera matrimoniale con
            armadiatura su misura, bagno finestrato.
          </div>
        </div>
        {/* Foto gallery */}
        <div style={{ padding: "0 22px 20px" }}>
          <div style={{ fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", color: "#7C8B6E", fontWeight: 700, marginBottom: 10 }}>
            8 foto
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
            <img src="/landing/cucina-after.jpg" alt="" style={{ width: "100%", aspectRatio: "1/1", objectFit: "cover", borderRadius: 8 }} />
            <img src="/landing/bagno-after.jpg" alt="" style={{ width: "100%", aspectRatio: "1/1", objectFit: "cover", borderRadius: 8 }} />
            <img src="/landing/camera-after.jpg" alt="" style={{ width: "100%", aspectRatio: "1/1", objectFit: "cover", borderRadius: 8 }} />
            <img src="/landing/rinnova-after.jpg" alt="" style={{ width: "100%", aspectRatio: "1/1", objectFit: "cover", borderRadius: 8 }} />
          </div>
        </div>
        {/* Mappa fake */}
        <div style={{ padding: "0 22px 20px" }}>
          <div style={{ fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", color: "#7C8B6E", fontWeight: 700, marginBottom: 10 }}>
            Posizione
          </div>
          <div style={{
            aspectRatio: "16/10",
            background: "linear-gradient(135deg, #DCE5C9 0%, #BFD0AC 100%)",
            borderRadius: 10,
            position: "relative",
            border: "1px solid #C8C2B4",
          }}>
            <div style={{ position: "absolute", inset: 0, opacity: 0.4, background: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Cpath d='M0 50 L100 50 M50 0 L50 100 M20 0 L20 100 M80 0 L80 100 M0 20 L100 20 M0 80 L100 80' stroke='%237C8B6E' stroke-width='1' opacity='0.4'/%3E%3C/svg%3E\")" }} />
            <div style={{
              position: "absolute", left: "50%", top: "50%",
              transform: "translate(-50%, -100%)",
              width: 26, height: 26, borderRadius: "50% 50% 50% 0",
              transformOrigin: "bottom",
              rotate: "-45deg",
              background: "#1C1C1A",
              boxShadow: "0 4px 8px rgba(0,0,0,0.25)",
            }} />
          </div>
        </div>
        {/* Contatti CTA */}
        <div style={{ padding: "0 22px 26px" }}>
          <div style={{ fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", color: "#7C8B6E", fontWeight: 700, marginBottom: 10 }}>
            Contatti diretti
          </div>
          <div style={{ background: "#FFFFFF", border: "1px solid #E2DED2", borderRadius: 12, padding: "16px 18px", display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ width: 48, height: 48, borderRadius: "50%", background: "#7C8B6E", color: "#FFFFFF", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 17 }}>CB</div>
            <div style={{ flexGrow: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#1C1C1A" }}>Carlo Bianchi</div>
              <div style={{ fontSize: 12, color: "#6B6A65", fontWeight: 500 }}>Agente referente</div>
            </div>
          </div>
          <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
            <div style={{ flexGrow: 1, padding: 13, background: "#7C8B6E", color: "#FFFFFF", textAlign: "center", borderRadius: 10, fontSize: 13, fontWeight: 700, letterSpacing: "0.04em" }}>Chiama</div>
            <div style={{ flexGrow: 1, padding: 13, background: "#1C1C1A", color: "#FFFFFF", textAlign: "center", borderRadius: 10, fontSize: 13, fontWeight: 700, letterSpacing: "0.04em" }}>Prenota visita</div>
          </div>
        </div>
      </div>
    </div>
  );
}

const MOCKUPS = {
  // 01 · ARREDA SPAZIO VUOTO con vuoto-before/after (foto belle landing)
  "arreda-vuoto": {
    Component: ArredaVuotoAnim,
    kicker: "Servizio · Arreda spazio vuoto",
    headline: ["Stanza vuota.", <span key="a">Pronto la <em>arreda</em>.</span>],
    tagline: [
      "carichi la foto vuota, scegli lo stile, il cliente la immagina ",
      <em key="t">già sua</em>,
      ". Niente home stager, niente costi, niente settimane di attesa.",
    ],
  },
  // 02 · MIGLIORA FOTO — stessa scena, solo luce + linee dritte
  "migliora-foto": {
    Component: MigliorafotoAnim,
    kicker: "Servizio · Migliora foto",
    headline: ["Foto storta.", <span key="a">Pronto la <em>sistema</em>.</span>],
    tagline: [
      "luce, contrasto, prospettiva: in 8 secondi la metti sui portali. ",
      <em key="t">Stessi mobili, stessa architettura</em>,
      ", solo la foto migliora.",
    ],
  },
  // 03 · RESTYLING con rinnova-before/after (vero restyling)
  "restyling": {
    Component: RestylingAnim,
    kicker: "Servizio · Restyling stanza",
    headline: ["Stanza datata.", <span key="a">Pronto la <em>rinnova</em>.</span>],
    tagline: [
      "cambi solo i mobili e la palette, non i muri. ",
      <em key="t">Stessa pianta, altro mondo</em>,
      ". Senza muratori, senza preventivi, senza cantiere.",
    ],
  },
  // 04 · SVUOTA STANZA (nuovo — opposto di arreda vuoto)
  "svuota": {
    Component: SvuotaStanzaAnim,
    kicker: "Servizio · Svuota stanza",
    headline: ["Stanza piena.", <span key="a">Pronto la <em>libera</em>.</span>],
    tagline: [
      "il proprietario ha lasciato i suoi mobili nell'annuncio? Tu li ",
      <em key="t">togli con un click</em>,
      ". Il cliente vede gli spazi veri, non i suoi divani.",
    ],
  },
  // 05 · VOLANTINO STIMA
  "volantino-stima": {
    Component: HeroVolantinoFlip,
    kicker: "Servizio · Volantino stima",
    headline: ["Volantino + stima.", <span key="a">In <em>12 secondi</em>.</span>],
    tagline: [
      "valore di mercato OMI + comparabili di zona + ",
      <em key="t">volantino A4 stampabile</em>,
      ". Lo porti al proprietario, lui capisce, tu chiudi l'incarico.",
    ],
  },
  // 06 · AGENDA VOCALE
  "agenda": {
    Component: HeroAgendaMockup,
    kicker: "Servizio · Agenda vocale",
    headline: ["L'agenda.", <span key="a">Te la <em>racconti</em>.</span>],
    tagline: [
      "premi, racconti la tua settimana in 30 secondi di voce. Pronto annota appuntamenti, follow-up, visite, firme. ",
      <em key="t">Niente quaderno, niente app da popolare a mano</em>,
      ".",
    ],
  },
  // 07 · SOPRALLUOGO LIVE
  "sopralluogo": {
    Component: HeroSopralluogoMockup,
    kicker: "Servizio · Sopralluogo live",
    headline: ["Sopralluogo.", <span key="a">Lui <em>prende tutto</em>.</span>],
    tagline: [
      "premi REC, cammini per casa, parli e scatti. Pronto trascrive, riconosce le stanze, salva le foto. ",
      <em key="t">Torni in agenzia con la scheda già pronta</em>,
      ".",
    ],
  },
  // 08 · AUGURI WHATSAPP
  "messaggi": {
    Component: HeroMessaggiMockup,
    kicker: "Servizio · Auguri WhatsApp",
    headline: ["Auguri al cliente.", <span key="a">Pronto li <em>scrive</em>.</span>],
    tagline: [
      "onomastici, anniversari, compleanni: chi se li ricorda tutti? Pronto sì. ",
      <em key="t">Messaggio personalizzato</em>,
      ", pronto da inviare. Il cliente si ricorda di te.",
    ],
  },
  // 09 · VETRINA PERSONALIZZATA con scroll automatico
  "vetrina": {
    Component: VetrinaScrollMockup,
    kicker: "Servizio · Vetrina personalizzata",
    headline: ["Un link.", <span key="a">Tutta la <em>casa dentro</em>.</span>],
    tagline: [
      "ogni annuncio ha la sua pagina dedicata, ",
      <em key="t">personalizzata col brand dell'agenzia</em>,
      ": cover, foto, descrizione, mappa, contatti. Il proprietario la condivide come una storia, in un link unico.",
    ],
  },
  // 10 · ASSISTENTE
  "assistente": {
    Component: HeroAssistantMockup,
    kicker: "Servizio · Assistente",
    headline: ["Una domanda tecnica.", <span key="a">L'assistente <em>risponde</em>.</span>],
    tagline: [
      "fisco, mutui, donazioni, successioni, contratti. ",
      <em key="t">Risposta tecnica precisa</em>,
      " in 12 secondi. Non sembri più impreparato davanti al cliente.",
    ],
  },
};

export default function MockupRecorder() {
  const [params] = useSearchParams();
  const id = params.get("id") || "arreda-vuoto";
  const spec = MOCKUPS[id];

  if (!spec) {
    return (
      <div style={{ padding: 40, fontFamily: "Montserrat" }}>
        Mockup id non riconosciuto: <strong>{id}</strong>
        <br /><br />
        Ids: {Object.keys(MOCKUPS).join(", ")}
      </div>
    );
  }

  const { Component, kicker, headline, tagline } = spec;

  return (
    <div
      data-testid="mockup-recorder"
      style={{
        width: 1080,
        height: 1350,
        background:
          "radial-gradient(ellipse at top, rgba(124,139,110,0.08), transparent 60%), radial-gradient(ellipse at bottom right, rgba(200,166,107,0.06), transparent 50%), #F1F4ED",
        fontFamily: "'Montserrat', system-ui, sans-serif",
        color: "#1C1C1A",
        position: "relative",
        padding: "70px 70px 60px 70px",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      {/* Hide cookie banner & altre overlay durante il recording */}
      <style>{`
        [data-testid="cookie-banner"], .cookie-banner, .CookieConsent,
        [class*="cookie"], [id*="cookie"], [class*="Cookie"] {
          display: none !important;
        }
      `}</style>
      {/* Paper grain overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/%3E%3CfeColorMatrix values='0 0 0 0 0.7 0 0 0 0 0.65 0 0 0 0 0.55 0 0 0 0 0.06 0'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
          pointerEvents: "none",
          opacity: 0.55,
          mixBlendMode: "multiply",
          zIndex: 0,
        }}
      />

      {/* TOP HEADER (kicker + headline) */}
      <div style={{ position: "relative", zIndex: 2, marginBottom: 14 }}>
        <div
          style={{
            fontSize: 12,
            letterSpacing: "0.34em",
            textTransform: "uppercase",
            color: "#7C8B6E",
            fontWeight: 600,
          }}
        >
          {kicker}
        </div>
        <div
          style={{
            fontWeight: 500,
            fontSize: 52,
            lineHeight: 1.06,
            letterSpacing: "-0.025em",
            color: "#1C1C1A",
            marginTop: 6,
            maxWidth: 700,
          }}
        >
          {headline[0]}
          <br />
          {headline[1]}
        </div>
      </div>

      {/* PHONE WRAPPER (centered) — iPhone 17 Pro */}
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px 0 16px 0",
          position: "relative",
          zIndex: 2,
        }}
      >
        <div style={{ width: 540, height: 1080 }}>
          <IPhone17ProFrame size="full" tone="titanium" testId="iphone-17-mockup">
            {/* The actual landing Hero mockup, fills remaining space. */}
            <div style={{ width: "100%", height: "100%", position: "relative", overflow: "hidden" }}>
              <Component />
            </div>
          </IPhone17ProFrame>
        </div>
      </div>

      {/* BOTTOM STRIP — solo tagline lunga, NIENTE prontoimmo.it (è nel watermark) */}
      <div
        style={{
          position: "relative",
          zIndex: 5,
          paddingTop: 18,
        }}
      >
        <div
          style={{
            fontSize: 22,
            fontWeight: 500,
            color: "#1C1C1A",
            lineHeight: 1.35,
            letterSpacing: "-0.005em",
            maxWidth: "78%",
          }}
        >
          <strong style={{ fontWeight: 700 }}>Pronto</strong> ·{" "}
          {tagline.map((t, i) =>
            typeof t === "string" ? (
              <span key={i}>{t}</span>
            ) : (
              React.cloneElement(t, {
                style: { color: "#7C8B6E", fontStyle: "italic", fontWeight: 600 },
              })
            )
          )}
        </div>
      </div>
    </div>
  );
}
